import {
  CacheLocation,
  FpjsProvider
} from '@fingerprintjs/fingerprintjs-pro-react'
import {ReactNode} from 'react'
import {FP_OPTIONS_PROD} from 'shared/lib/constants'

export const withFP = (component: () => ReactNode) => () => (
  <FpjsProvider
    loadOptions={FP_OPTIONS_PROD}
    cacheLocation={CacheLocation.LocalStorage}
  >
    {component()}
  </FpjsProvider>
)
